// Which stored files the preview dialog can show, and how it shows them.
//
// One table, imported both by the page that decides whether to open the dialog
// and by the dialog that decides what to render. There used to be two: an
// exact-match set here in the page, and a family check inside the modal that
// put anything whose type began with "text/" into an iframe. The looser of the
// two is the one that decided what actually got framed, so the set was never
// really the gate it looked like.
//
// text/html is deliberately absent. A blob: URL inherits the origin of the
// document that created it, so an HTML file rendered in this iframe would run
// its own script on core.ammoimaging.com, against the session of whoever
// opened it — and any user can upload one. It downloads instead. text/xml and
// application/xml are absent for the same reason: a browser renders XML as a
// document, and a stylesheet instruction inside one is script.
//
// image/* is matched by family, which does include image/svg+xml, and that is
// safe only because of how the modal renders it. An <img> tag never executes
// the script inside an SVG; a frame or a direct navigation does. So the image
// branch in FilePreviewModal has to stay an <img>. If it ever becomes an
// iframe, SVG has to be carved out of this check first.
export const PREVIEWABLE_EXACT = new Set([
  "application/pdf",
  "text/plain",
  "text/css",
  "text/javascript",
  "application/json",
]);

// Whether the preview dialog can show this at all. When it cannot, the caller
// downloads the file instead of opening an empty dialog.
export function canPreview(contentType) {
  if (!contentType) return false;
  return contentType.startsWith("image/") || PREVIEWABLE_EXACT.has(contentType);
}

// How to render it: "image", "pdf", "text", or null when it is not previewable.
// Derived from the same check rather than restated, so the dialog cannot end up
// rendering something the page never agreed to preview.
export function previewMode(contentType) {
  if (!canPreview(contentType)) return null;
  if (contentType.startsWith("image/")) return "image";
  if (contentType === "application/pdf") return "pdf";
  return "text";
}
